/** @prettier */
import { push } from 'react-router-redux';

import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from '@xanadu/ui-shared/modules/userSession/actions';

import { setCasinoVisibilityRestricted } from '../vegas/actions';
import { all, fork, put, take, takeLatest } from 'redux-saga/effects';

function* handleCasinoPromotionsRedirect({ type, payload }) {
  const path = window.location.pathname;

  const isLoggedOut = type === LOGOUT_SUCCESS;

  const { isLogin } = payload || {};

  if (path.indexOf('/promotions/casino/') > -1 && (isLogin || isLoggedOut)) {
    yield put(push('/promotions/casino'));
  }
}

function* watchForLogoutSuccess() {
  while (true) {
    yield take(LOGOUT_SUCCESS);

    yield put(setCasinoVisibilityRestricted(false));
  }
}

export default function* root() {
  yield all([
    fork(watchForLogoutSuccess),
    takeLatest([LOGIN_SUCCESS, LOGOUT_SUCCESS], handleCasinoPromotionsRedirect),
  ]);
}
